import type { ComponentType } from "react";
import type { IconProps } from "@/sprout/icons/base";
import CalendarIcon from "@/sprout/icons/calendar";
import FormIcon from "@/sprout/icons/form";

export type GhrTaskConfig = {
  icon: ComponentType<IconProps>;
  titleKey: string;
  actionTextKey: string;
};

const GHR_TASK_CONFIG: Record<string, GhrTaskConfig> = {
  ApplicationFormTask: {
    icon: FormIcon,
    titleKey: "application_form.title",
    actionTextKey: "application_form.fill_out_form",
  },
  AvailabilityTask: {
    icon: CalendarIcon,
    titleKey: "availability.title",
    actionTextKey: "availability.share_availability",
  },
  CandidateSurvey: {
    icon: FormIcon,
    titleKey: "candidateSurvey.title",
    actionTextKey: "candidateSurvey.completeSurvey",
  },
  SelfScheduleRequest: {
    icon: CalendarIcon,
    titleKey: "self_schedule.title",
    actionTextKey: "self_schedule.schedule_interview",
  },
  TakeHomeTest: {
    icon: FormIcon,
    titleKey: "takeHomeTest.title",
    actionTextKey: "takeHomeTest.review_and_upload",
  },
  ThirdPartyTakeHomeTest: {
    icon: FormIcon,
    titleKey: "takeHomeTest.third_party_title",
    actionTextKey: "takeHomeTest.review_and_upload",
  },
  IdentityVerificationTask: {
    icon: CalendarIcon,
    titleKey: "identityVerification.title",
    actionTextKey: "identityVerification.startVerification",
  },
};

export default GHR_TASK_CONFIG;
